module.exports = __webpack_public_path__ + "img/sun-cloud-storm.563fe32.svg";